import * as Sentry from '@sentry/nextjs';

import ApiError from '@/helpers/ApiError';

import { logError } from '../ErrorTracking/logError';

export type TransactionNames = 'sign-in' | 'sign-up' | 'send-message' | 'cart-submit';

export default class SystemHealthMonitor {
  sentrySpan: Sentry.Span | null;

  constructor(name: TransactionNames) {
    try {
      const sentrySpan = Sentry.startInactiveSpan({
        name,
        op: 'health_monitor',
      });
      sentrySpan?.setAttributes({
        health: name,
        healthState: 'incomplete',
      });
      this.sentrySpan = sentrySpan || null;
    } catch (error) {
      logError(error);
      this.sentrySpan = null;
    }
  }

  getState(error: ApiError): string {
    if (
      (error.type === 'LoginFailedError' && error.reason() === 'Wrong password') ||
      (error.type === 'OTPVerificationError' && error.reason() === 'Incorrect code') ||
      error.type === 'IsLandlinePhoneNumberError' ||
      error.type === 'LoginNoSuchUserError'
    ) {
      return 'ignore';
    }

    return 'error';
  }

  finish(error?: unknown | null): void {
    if (!this.sentrySpan) {
      return;
    }
    try {
      if (error) {
        const apiError = ApiError.create(error);
        const state = this.getState(apiError);
        this.sentrySpan.setAttributes({
          healthReason: apiError.reason(),
          healthState: state,
        });
        // TODO: Set proper span status once we figure out the correct SpanStatusCode enum values
      } else {
        this.sentrySpan.setAttributes({
          healthReason: 'successful',
          healthState: 'ok',
        });
        // TODO: Set proper span status once we figure out the correct SpanStatusCode enum values
      }
      this.sentrySpan.end();
    } catch (finishError) {
      logError(finishError);
    }
  }
}
